module.exports = __webpack_public_path__ + "img/3.3ac8d7fd.jpg";